import { checkFreelancerData } from './utils/navigation-guards';

export default [{
  name: 'profile overview',
  path: '/settings/profile',
  component: () => import('@web/pages/settings/profile/ProfileOverview.vue'),
  meta: { title: 'Profiel' },
  beforeEnter: [checkFreelancerData],
  children: [
    {
      name: 'profile',
      path: '',
      components: {
        detailColumn: () => import('@web/pages/settings/profile/detail-column/Index.vue'),
      },
      meta: { 
        title: 'Profiel',
        showContent: true
      },
      beforeEnter: [checkFreelancerData],
    },
    {
      name: 'personal edit',
      path: '/settings/profile/personal/edit',
      components: {
        detailColumn: () => import('@web/pages/settings/profile/detail-column/personal/EditPersonal.vue'),
      },
      meta: { title: 'Persoonsgegevens aanpassen' },
    },
    {
      name: 'address edit',
      path: '/settings/profile/address/edit',
      components: {
        detailColumn: () => import('@web/pages/settings/profile/detail-column/address/EditAddress.vue'),
      },
      meta: { title: 'Adresgegevens aanpassen' },
    },
    {
      name: 'contact edit',
      path: '/settings/profile/contact/edit',
      components: {
        detailColumn: () => import('@web/pages/settings/profile/detail-column/contact/EditContact.vue'),
      },
      meta: { title: 'Contactgegevens aanpassen' },
      beforeEnter: [checkFreelancerData],
    },
    {
      name: 'company edit',
      path: '/settings/profile/company/edit',
      components: {
        detailColumn: () => import('@web/pages/settings/profile/detail-column/company/EditCompany.vue'),
      },
      meta: { title: 'Bedrijfsgegevens aanpassen' },
      beforeEnter: [checkFreelancerData],
    },
    {
      name: 'bank edit',
      path: '/settings/profile/bank/edit',
      components: {
        detailColumn: () => import('@web/pages/settings/profile/detail-column/bank/EditBankDetails.vue'),
      },
      meta: { title: 'Bankgegevens aanpassen' },
      beforeEnter: [checkFreelancerData],
    },
  ]
}];
